'use strict';

angular.module('systemOwnerReviewRoutes', ['systemOwnerReviewRoutes.ConfirmSystemOwnership',
                                           'systemOwnerReviewRoutes.DecommissionSystems',
                                           'systemOwnerReviewRoutes.ReviewUniquePermissions',
                                           'systemOwnerReviewControllers',
                                           'services.systemOwnerReview',
                                           'services.authenticatedUser'])

.config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
    $stateProvider
        .state('systemOwnerReview', {
            url: '/SystemOwner/Review',
            templateUrl: require('./MainSystemOwnerReview.tpl.html'),
            controller: 'MainSystemOwnerReviewController',
            resolve: {
                authUser: ['authenticatedUserService', function (service) {
                    return service.getAuthenticatedUser();
                }]
            }
        })

        .state('systemOwnerReview.noReview', {
            url: '/NoReview',
            templateUrl: require('./noReview.tpl.html')
        })

        .state('systemOwnerReview.authUser', {
            url: '/{authLogin}',
            template: '<div ui-view/>',
            controller: 'SystemOwnerAuthUserController',
            resolve: {
                currentPeriod: ['systemOwnerReviewService', function (service) {
                    return service.getCurrentPeriod();
                }],
                authLogin: ['$stateParams', 'authUser', function ($stateParams, authUser) {
                    var authLogin = $stateParams.authLogin;
                    var realAuthLogin = authUser.IdentityName;

                    if (_.isEmpty(authLogin)) return realAuthLogin.toLowerCase();

                    if (authLogin.toUpperCase() !== realAuthLogin.toUpperCase() &&
                        !authUser.IsInAdministrationGroup) {

                        authLogin = realAuthLogin;
                    }

                    return authLogin.toLowerCase();
                }],
                nextProcessStep: ['systemOwnerReviewService', 'authLogin', function (service, authLogin) {
                    return service.getNextProcessStep(authLogin);
                }]
            }
        })

        .state('systemOwnerReview.authUser.gettingStarted', {
            url: '/GettingStarted',
            templateUrl: require('./GettingStarted.tpl.html'),
            controller: 'SystemOwnerReviewGettingStartedController'
        })

        .state('systemOwnerReview.authUser.completed', {
            url: '/Completed',
            templateUrl: require('./Completed.tpl.html'),
            controller: 'SystemOwnerReviewCompletedController'
        });
}]);